<!--  -->
<template>
  <div
    class="page"
    @click="showExam = false"
    @touchstart="touchStart"
    @touchmove="touchMove"
    @touchend="touchEnd"
    :class="{ isEnd: isUpEnd }"
  >
    <div class="cover-img">
      <img
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyBook/main2.png"
        alt=""
      />
      <div class="year" v-if="examSeasonList.length">
        <div
          class="current"
          :class="{ more: examSeasonList.length == 1 }"
          @click.stop.prevent="showExam = !showExam"
        >
          <span>{{ currentExam.value }}</span>
        </div>
        <div class="list" v-show="showExam && examSeasonList.length > 1">
          <p v-for="(item, k) in examSeasonList" @click="changeExam(item)" :key="k">
            {{ item.value }}
          </p>
        </div>
      </div>
    </div>
    <div class="demo" v-if="isFix"></div>
    <div class="top-nav" :class="{ active: isFix }">
      <div class="tab">
        <div
          class="subject"
          :class="{ active: idx === k }"
          @click="changeSubject(item, 1, k)"
          v-for="(item, k) in subjectList"
          :key="k + 10"
        >
          {{ item.majorName }}
        </div>
      </div>
      <div class="sub-tab" v-if="childMajorList.length">
        <div
          class="major"
          :class="{ active: subIdx === k, two: subjectType !== 5 }"
          v-for="(item, k) in childMajorList"
          @click="changeSubject(item, 2, k)"
          :key="`${new Date().getTime()}-${k}`"
        >
          {{ item.secondarySubject }}
        </div>
      </div>
    </div>
    <div class="section">
      <div
        class="bar"
        v-if="bookStudyDetail.length"
        :class="{ active: isFix, child: childMajorList.length }"
      >
        <div v-if="bookStudyDetail.length">
          <template v-for="(item, i) in bookStudyDetail">
            <div class="time" :key="i">{{ item.month[0] }}月</div>
            <div class="btn" @click="changeStage(i)" :class="{ active: item.selected }" :key="i">
              {{ item.name }}
            </div>
          </template>
          <div class="time">{{ bookStudyDetail[bookStudyDetail.length - 1].month[1] }}月</div>
        </div>
        <img
          v-if="bookStudyDetail.length"
          class="line"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyBook/line.png"
          alt=""
        />
      </div>
      <div class="empty" v-if="isFix"></div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <template #pulling="props">
          <p>下拉至上一阶段</p>
        </template>
        <!-- 释放提示 -->
        <template #loosing>
          <p>下拉至上一阶段</p>
        </template>
        <div class="content">
          <div class="book-box" v-if="bookList.length">
            <h1 class="name" id="name">
              <b>书课包</b><span>一本书的价格 =大咖网课+课后测练答+社群督学</span>
            </h1>
            <BookCard
              v-for="(item, index) in bookList"
              :key="index + 100"
              :item="item"
              @addBook="addShooping"
            />
          </div>
          <div class="course-box" v-if="courseList.length">
            <h1 class="name"><b>系统好课</b><span>大咖网课 + 特色服务 + 配套资料</span></h1>
            <div class="card">
              <CourseCard
                v-for="(item, i) in courseList"
                :key="i"
                :item="item"
                @addBook="addShooping"
              />
            </div>
          </div>
          <div class="no-data" v-if="!bookList.length && !courseList.length">
            <img
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyBook/no-data.png"
              alt=""
            />
            <p>敬请期待～</p>
          </div>
        </div>
        <div class="refreshing" v-if="refreshing && !isDownEnd">
          {{ refreshing === 1 ? '' : '上拉至下一阶段' }}
        </div>
      </van-pull-refresh>
    </div>
    <Transition ref="animate" />
    <SelectSku ref="sku" v-if="courseInfo" :courseInfo="courseInfo" @sendSku="sendSku" />
    <div class="shoppingBtn" @click="openShopping"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import wx from 'weixin-js-sdk';
import { reqAddCart } from '@/api/courseDetail/shoppingCar/shoppingCar';
import { reqProductsNew } from '@/api/home';
import { resetProductData } from '@/utils/tools';
import { reqExamSeason, reqSubject, reqStudyDetail } from '@/api/studyBook/index';
import { reqCourseDetail } from '@/api/courseDetail/index';
import { reqTypeList } from '@/api/home';
import CourseCard from './components/courseCard.vue';
import BookCard from './components/bookCard.vue';
import Transition from './components/transition.vue';
import SelectSku from './components/selectSku.vue';
import { Facet } from '@antv/g2plot';

export default {
  components: {
    CourseCard,
    BookCard,
    Transition,
    SelectSku,
  },
  data() {
    return {
      isApp: this.$root.$data.isApp,
      miniprogram: this.$root.$data.miniprogram,
      examSeasonList: [],
      showExam: false,
      currentExam: {},
      subjectType: 0,
      subjectList: [],
      childMajorList: [],
      bookClassStudyId: '', // 书课ID
      bookStudyDetail: {},
      idx: 0,
      subIdx: 0,
      bookList: [],
      courseList: [],
      isFix: false,
      courseInfo: null,
      target: null,
      isLoading: false,
      refreshing: 0,
      isScrollBottom: false,
      StarTime: 0,
      isUpEnd: false,
      isDownEnd: false,
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    // 查考级列表
    async getExamSeason() {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const res1 = await reqExamSeason();
      const res2 = await reqTypeList('MINI_CONSULTING_EXAM_SEASON');
      const data = res1.data.map((element) => {
        const temp = res2.data.find((item) => Number(item.code) === Number(element.examSeason));
        const { remark, code } = temp;
        return {
          value: remark,
          examSeason: Number(code),
        };
      });
      if (!data.length) {
        this.$toast.clear();
        return;
      }
      this.examSeasonList = data;
      const book_currentExam = window.sessionStorage.getItem('book_currentExam');
      if (book_currentExam) {
        this.currentExam = data.find(
          (ele) => ele.examSeason === JSON.parse(book_currentExam).examSeason,
        );
      } else {
        this.currentExam = data[0];
      }

      this.getSubjectList(this.currentExam.examSeason);
    },
    // 查学科
    async getSubjectList(id) {
      const { data } = await reqSubject(id);
      const data1 = [
        {
          bookClassStudyId: 1,
          secondarySubjectVOList: null,
          subjectType: 1,
        },
        {
          bookClassStudyId: 2,
          secondarySubjectVOList: [
            {
              bookClassStudyId: 10,
              secondarySubject: '计算机',
            },
            {
              bookClassStudyId: 11,
              secondarySubject: '西医',
            },
          ],
          subjectType: 5,
        },
      ];
      const obj = {
        1: '数学',
        2: '英语',
        3: '政治',
        4: '经管',
        5: '专业课',
      };
      data.forEach((ele) => {
        Object.assign(ele, { majorName: obj[ele.subjectType] });
      });

      const book_idx = window.sessionStorage.getItem('book_idx');
      const book_subIdx = window.sessionStorage.getItem('book_subIdx');
      this.idx = book_idx ? Number(book_idx) : 0;
      this.subIdx = book_subIdx ? Number(book_subIdx) : 0;
      const temp = data[book_idx ? Number(book_idx) : 0];
      const { bookClassStudyId, secondarySubjectVOList, subjectType } = temp;
      if (secondarySubjectVOList?.length) {
        this.bookClassStudyId =
          secondarySubjectVOList[
            book_subIdx ? book_subIdx || Number(book_subIdx) : 0
          ]?.bookClassStudyId;
        this.childMajorList = secondarySubjectVOList;
      } else {
        this.bookClassStudyId = bookClassStudyId;
      }
      this.subjectType = subjectType;
      console.log(this.bookClassStudyId, 'data23');
      this.subjectList = data;
      this.getSubjectDetail(this.bookClassStudyId);
    },
    // 查书课详情
    async getSubjectDetail(id) {
      const { data } = await reqStudyDetail(id);
      const tempObj = [
        {
          month: data.basicStageMonths?.split(','),
          selected: true,
          bookIds: data.basicStageBookCourseList,
          courseIds: data.basicStageOtherCourseList,
          name: '基础阶段',
        },
        {
          month: data.intensiveStageMonths?.split(','),
          selected: false,
          bookIds: data.intensiveStageBookCourseList,
          courseIds: data.intensiveStageOtherCourseList,
          name: '强化阶段',
        },
        {
          month: data.sprintStageMonths?.split(','),
          selected: false,
          bookIds: data.sprintStageBookCourseList,
          courseIds: data.sprintStageOtherCourseList,
          name: '冲刺阶段',
        },
      ];
      let falg = false;
      const book_stage = window.sessionStorage.getItem('book_stage');
      if (book_stage) {
        tempObj.forEach((item, i) => {
          if (Number(book_stage) === i) {
            Object.assign(item, { selected: true });
            falg = i === 0 ? false : true;
            this.isUpEnd = i === 0 ? true : false;
            this.isDownEnd = i === 2 ? true : false;
          }
        });
         window.sessionStorage.removeItem('book_stage');
      } else {
        tempObj.forEach((item, i) => {
          const nowMonth = new Date().getMonth() + 1;
          if (nowMonth >= item.month[0] && nowMonth <= item.month[1]) {
            Object.assign(item, { selected: true });
            falg = i === 0 ? false : true;
            this.isUpEnd = i === 0 ? true : false;
            this.isDownEnd = i === 2 ? true : false;
          }
        });
      }

      if (falg) {
        tempObj[0].selected = false;
      }
      this.bookStudyDetail = tempObj;
      const findRes = tempObj?.find((item) => item.selected);
      console.log(findRes, tempObj, 'findRes');
      await this.getBookList(findRes.bookIds || []);
      await this.getCourseList(findRes.courseIds || []);
      this.$toast.clear();
    },
    // 查课程列表
    async getBookList(bookIds) {
      this.bookList = [];
      if (!bookIds?.length) return;
      const ids = bookIds.map((item) => item.businessId);
      const { data } = await reqProductsNew(ids);
      const resCourse = resetProductData(data || []);
      this.bookList = resCourse;
      console.log(this.bookList, 'this.bookList');
    },
    // 查课程列表
    async getCourseList(courseIds) {
      this.courseList = [];
      if (!courseIds?.length) return;
      const ids = courseIds.map((item) => item.businessId);
      const { data } = await reqProductsNew(ids);
      const resCourse = resetProductData(data || []);
      this.courseList = resCourse;
      console.log(this.courseList, 'this.courseList');
    },
    // 切换考级
    changeExam(data) {
      this.showExam = false;
      if (this.currentExam.examSeason === data.examSeason) {
        return;
      }
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      this.currentExam = data;
      this.getSubjectList(this.currentExam.examSeason);
      this.clearIndex();
    },
    // 切换学科
    async changeSubject(item, type, index) {
      const { bookClassStudyId, secondarySubjectVOList, subjectType } = item;
      this.bookClassStudyId = bookClassStudyId;
      if (type === 1) {
        this.idx = index;
        this.subIdx = 0;
        this.childMajorList = secondarySubjectVOList || [];
        this.subjectType = subjectType;
      } else {
        this.subIdx = index;
      }
      if (secondarySubjectVOList?.length) {
        this.bookClassStudyId = secondarySubjectVOList?.[0]?.bookClassStudyId;
      }
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      this.getSubjectDetail(this.bookClassStudyId);
    },
    // 切换阶段
    async changeStage(i) {
      // this.refreshing = 0;
      // this.StarTime = 0;
      this.isScrollBottom = false;
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const arr = JSON.parse(JSON.stringify(this.bookStudyDetail));
      arr.forEach((item, index) => {
        Object.assign(item, { selected: false });
        if (i === index) {
          Object.assign(item, { selected: true });
          this.isUpEnd = index === 0 ? true : false;
          this.isDownEnd = index === 2 ? true : false;
        }
      });
      this.bookStudyDetail = arr;
      const findRes = arr?.find((item) => item.selected);
      await this.getBookList(findRes.bookIds || []);
      await this.getCourseList(findRes.courseIds || []);
      this.$toast.clear();
    },
    async addShooping(data) {
      const { event, item } = data;
      const { productSkuSimpleVOS, productId } = item;
      if (!this.userInfo?.id) {
        this.openLogin();
      } else if (productSkuSimpleVOS?.length > 1) {
        await this.getCourseSku(productId);
        this.$refs.sku.show = true;
        this.target = event;
      } else {
        const data = await this.addddShopCar(productId, productSkuSimpleVOS[0].productSkuId);
        data && this.$refs.animate.drop(event);
      }
    },
    // 加入购物车
    async addddShopCar(productId, skuId) {
      const query = {
        productId,
        skuId,
        type: 1, // 类型 1 产品 2 套餐
      };
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const { code, msg } = await reqAddCart(query);
      this.$toast.clear();
      if (code) {
        this.$toast(msg);
      }
      return !code;
    },
    async sendSku(data) {
      this.$refs.sku.show = false;
      const { productId, productSkuId } = data;
      const res = await this.addddShopCar(productId, productSkuId);
      res && this.$refs.animate.drop(this.target);
    },
    // 查课程sku
    async getCourseSku(id) {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const { data } = await reqCourseDetail(id);
      this.$toast.clear();

      this.courseInfo = data;
    },
    // 去登录
    openLogin() {
      if (this.isApp) {
        this.$sendToApp('login');
      } else if (this.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();
          params.forEach((item) => {
            const [key, value] = item.split('=');
            //  console.log('key', key, value);
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
          }
          url = `${domain}?${query}`;
          const redirctUrl = encodeURIComponent(
            `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`,
          );
          const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
          wx.miniProgram.redirectTo({
            url: path,
          });
        }
      } else {
        this.$router.push({
          path: '/registrationLogin',
          query: { redirect: '/studyBook' },
        });
      }
    },
    openShopping() {
      if (this.userInfo.id) {
        this.$router.push({
          path: '/shoppingCar',
          query: {
            beforePageName: 1,
          },
        });
      } else {
        this.openLogin();
      }
    },
    // app 登录回掉
    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
    },
    handleScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      this.isFix = !!(scrollTop > 165);

      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      if (scrollTop + windowHeight >= documentHeight) {
        console.log('1111', '到底了');
        this.isScrollBottom = true;
      } else {
        this.isScrollBottom = false;
      }
    },
    onRefresh() {
      console.log('11111---到顶了');
      this.isLoading = false;
      this.bookStudyDetail.forEach((item, index) => {
        if (item.selected && index > 0) {
          this.changeStage(index - 1);
        }
      });
    },
    touchStart(e) {
      if (!this.isScrollBottom) return;
      console.log(1111111, '开始滑-----');
      this.StarTime = new Date().getTime();
      this.refreshing = 1;
    },
    touchMove(e) {
      if (!this.isScrollBottom) return;
      this.refreshing = 1;
      this.EndTime = new Date().getTime();
      if (this.EndTime - this.StarTime > 300) {
        this.refreshing = 2;
      }
    },
    touchEnd() {
      if (!this.isScrollBottom) return;
      if (this.refreshing === 2) {
        this.refreshing = 0;
        this.StarTime = 0;
        this.bookStudyDetail.forEach((item, index) => {
          if (item.selected && index < 2) {
            this.changeStage(index + 1);
          }
        });
      }
    },
    cacheIndex() {
      this.bookStudyDetail.forEach((item, index) => {
        if (item.selected) {
          window.sessionStorage.setItem('book_stage', index);
        }
      });
      window.sessionStorage.setItem('book_currentExam', JSON.stringify(this.currentExam));
      window.sessionStorage.setItem('book_idx', this.idx);
      window.sessionStorage.setItem('book_subIdx', this.subIdx);
    },
    clearIndex() {
      window.sessionStorage.removeItem('book_idx');
      window.sessionStorage.removeItem('book_subIdx');
    },
  },
  created() {},
  mounted() {
    document.title = '书课学习';
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
    this.getExamSeason();
    window.addEventListener('scroll', this.handleScroll);
    window.localStorage.setItem('miniBeforePageName', 13);
    setTimeout(() => {
      this.isScrollBottom = true;
    }, 5000);
  },
  destroyed() {
    this.cacheIndex();
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}
.page.isEnd {
  ::v-deep .van-pull-refresh__head {
    display: none;
  }

}
.page {
  width: 100%;
  max-width: 750px;
  min-height: 100vh;
  margin: 0 auto;
  background: #fdeee8;
  ::v-deep .van-pull-refresh {
    width: 100%;
  }
  .cover-img {
    position: relative;
    img {
      width: 750px;
      height: 442px;
    }
    .year {
      position: absolute;
      top: 29px;
      right: 29px;
      .current {
        display: flex;
        align-items: center;
        width: 138px;
        height: 51px;
        padding: 0 14px;
        background: #000;
        background: rgba($color: #000, $alpha: 0.55);
        border-radius: 11px;
        span {
          display: inline-block;
          padding-right: 11px;
          color: #fff;
          font-weight: 500;
          font-size: 25px;
          line-height: 51px;
        }
      }

      .current::after {
        position: relative;
        display: block;
        width: 16px;
        height: 9px;
        background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyBook/arrow.png')
          no-repeat;
        background-size: 100%;
        content: '';
      }
      .current.more::after {
        display: none;
      }
      .current.more {
        justify-content: center;
        span {
          padding-right: 0;
        }
      }
      .list {
        width: 138px;
        min-height: 130px;
        padding: 14px 0;
        background: #fff;
        border-radius: 14px;
        box-shadow: 0 4 7px 0 rgba(0, 0, 0, 0.05);
        p {
          padding: 7px 0;
          color: #333;
          font-weight: 400;
          font-size: 25px;
          line-height: 36px;
          text-align: center;
        }
      }
    }
  }
  .top-nav.active {
    position: fixed;
    top: 0;
    z-index: 10;
    padding-top: 8px;
    .sub-tab {
      box-shadow: 5px 5px 10px 0 #eee;
    }
  }
  .head {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 109px;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyBook/head.png');
    background-size: 100%;
  }
  .top-nav {
    width: 100%;
    background: #fdeee8;
    .tab {
      display: flex;
      flex-shrink: 0;
      flex-wrap: nowrap;
      margin-left: 27px;
      overflow-x: scroll;
      white-space: nowrap;
      .subject {
        flex: 0 0 auto;
        box-sizing: border-box;
        width: 141px;
        height: 65px;
        margin-right: 7px;
        color: #9a5245;
        font-weight: 500;
        font-size: 25px;
        line-height: 65px;
        text-align: center;
        background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyBook/subject.png')
          no-repeat;
        background-size: 100%;
      }

      .subject.active {
        height: 76px;
        color: #fff;
        line-height: 65px;
        background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyBook/subject-active.png')
          no-repeat;
        background-size: 100%;
      }
    }

    .sub-tab {
      display: flex;
      flex-shrink: 0;
      flex-wrap: nowrap;
      align-items: center;
      width: 678px;
      height: 58px;
      margin: 22px auto 0;
      overflow-x: scroll;
      white-space: nowrap;
      background: #fff;
      border-radius: 14px;
      .major.two {
        justify-content: space-around;
        width: 50%;
        text-align: center;
      }
      .major {
        position: relative;
        flex: 0 0 auto;
        height: 58px;
        margin-right: 15px;
        padding: 0 18px;
        color: #333 !important;
        font-weight: 400;
        font-size: 25px;
        line-height: 58px;
      }
      .major.active {
        color: #ff7f41 !important;
        font-weight: 400;
        font-size: 25px;
      }
      .major.active::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        display: block;
        width: 29px;
        height: 7px;
        margin: 0 auto;
        background: #ff7f41;
        border-radius: 4px;
        content: '';
      }
    }
  }
  .section {
    display: flex;
    width: 100%;
    padding: 36px 0 22px 0;
    .bar.active.child {
      top: 301px;
    }
    .bar.active {
      position: fixed;
      top: 221px;
    }
    .empty {
      flex-shrink: 0;
      width: 100px;
    }
    .bar {
      z-index: 1;
      display: flex;
      flex-shrink: 0;
      width: 110px;
      height: max-content;
      background: #fdeee8;
      .line {
        width: 14px;
        height: 764px;
        margin-top: 10px;
      }
      .time {
        position: relative;
        padding-left: 36px;
        color: #a92316;
        font-weight: 600;
        font-size: 25px;
        line-height: 36px;
      }

      .btn {
        position: relative;
        width: 60px;
        height: 138px;
        margin-top: 38px;
        margin-bottom: 38px;
        margin-left: 36px;
        padding: 7px 25px 7px 13px;
        color: #5c5251;
        font-weight: 400;
        font-size: 22px;
        line-height: 31px;
        background: #ffe3d2;
        background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyBook/btn1.png?v=1');
        background-size: 100%;
        border-radius: 0 11px 11px 0;
      }
      .btn.active {
        color: #fff;
        background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyBook/btn2.png?v=1');
        background-size: 100%;
      }
    }
    .refreshing {
      padding: 20px 0 30px 0;
      color: #999;
      font-size: 24px;
      text-align: center;
    }
    .content {
      width: 100%;
      min-height: 800px;
      padding-left: 24px;
      .name {
        display: flex;
        align-items: center;
        padding-bottom: 22px;
        b {
          padding-right: 7px;
          color: #333;
          font-weight: 600;
          font-size: 29px;
        }
        span {
          color: #666;
          font-weight: 400;
          font-size: 22px;
        }
      }
      .card {
        display: flex;
        flex-wrap: wrap;
        .dkillItem {
          margin-right: 14px;
        }
      }
      .course-box {
        margin-top: 36px;
      }
      .no-data {
        padding-top: 300px;
        text-align: center;
        img {
          width: 308px;
          height: 226px;
        }
        p {
          padding-top: 14px;
          color: #999;
          font-weight: 400;
          font-size: 25px;
          text-align: center;
        }
      }
    }
  }

  .shoppingBtn {
    position: fixed;
    bottom: 60px;
    left: 71px;
    z-index: 3;
    width: 116px;
    height: 116px;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/studyBook/shopping-btn1.png')
      no-repeat;
    background-size: 100%;
  }
}
.demo {
  width: 100%;
  height: 156px;
}
</style>
